import { OptionsIcon } from '@assets/icons';
import { IconButton } from '@components/button';
import { useModal } from '@components/modal';
import { Typography } from '@components/typography';
import { Box, Menu, MenuItem } from '@mui/material';
import {
  JobsConfigurationsOptionsEditModal,
  JobsConfigurationsPreviewOptionsDownloadModal,
} from '@subsets/workspaces';
import { MouseEvent, useState } from 'react';

interface JobsConfigurationsPreviewOptionsDropdownProps {
  graphId: string;
  graphName: string;
  graphDescription: string;
  graphTags: string[];
  workspaceId: string;
  deleteHandle: () => void;
  refetch: () => void;
}

export const JobsConfigurationsPreviewOptionsDropdown = ({
  graphId,
  graphName,
  graphDescription,
  graphTags,
  deleteHandle,
  workspaceId,
  refetch,
}: JobsConfigurationsPreviewOptionsDropdownProps) => {
  const [anchorEl, setAnchorEl] = useState<Element | (() => Element)>(null);
  const open = Boolean(anchorEl);

  const handleClose = () => setAnchorEl(null);
  const handleClick = (event: MouseEvent) => setAnchorEl(event.currentTarget);

  const { showModal: showRenameModal } = useModal({
    component: JobsConfigurationsOptionsEditModal,
    componentProps: { graphId, graphName, graphDescription, graphTags, workspaceId, refetch },
    modalProps: { title: 'Edit staged graph' },
  });

  const handleRenameOpen = () => {
    showRenameModal();
    handleClose();
  };

  const { showModal: showDownloadModal } = useModal({
    component: JobsConfigurationsPreviewOptionsDownloadModal,
    componentProps: { graphId, name: graphName, workspaceId },
    modalProps: { title: `Download ${graphName}` },
  });

  const handleDownloadOpen = () => {
    showDownloadModal();
    handleClose();
  };
  const handleDeleteOpen = () => {
    deleteHandle();
    handleClose();
  };

  return (
    <Box>
      <IconButton onClick={handleClick} Icon={OptionsIcon} size={22} />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <MenuItem onClick={handleRenameOpen}>
          <Typography variant="body2">Edit</Typography>
        </MenuItem>
        <MenuItem onClick={handleDownloadOpen}>
          <Typography variant="body2">Download</Typography>
        </MenuItem>
        <MenuItem onClick={handleDeleteOpen}>
          <Typography variant="body2">Delete</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
};
